import { render, staticRenderFns } from "./WebinarEdit.vue?vue&type=template&id=a3b5c066&"
import script from "./WebinarEdit.vue?vue&type=script&lang=ts&"
export * from "./WebinarEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports